export const Backspace = "Backspace";
export const DELETE = "Delete";
export const TRUE = "true";
export const FALSE = "false";
